import React, { forwardRef, useEffect, useImperativeHandle } from 'react'
import { Box } from '@chakra-ui/react'

import { useForm, FormProvider } from './useForm'

export const Form = forwardRef(
  (
    {
      mode,
      data,
      context,
      resolver,
      onError,
      onSubmit,
      criteriaModem,
      reValidateMode,
      shouldUnregister,
      shouldFocusError,
      isError,
      isLoading,
      ...props
    },
    ref
  ) => {
    const formContext = useForm({
      mode,
      data,
      context,
      resolver,
      onSubmit,
      criteriaModem,
      reValidateMode,
      shouldUnregister,
      shouldFocusError,
      isError,
      isLoading
    })
    const { reset, handleSubmit } = formContext
    useEffect(() => reset(data), [reset, data])
    useImperativeHandle(ref, () => ({
      submit: handleSubmit(onSubmit, onError)
    }))

    return (
      <FormProvider value={formContext}>
        <Box w='full' {...props} as='form' onSubmit={handleSubmit(onSubmit, onError)} />
      </FormProvider>
    )
  }
)

export default Form
